import React from "react";
import { FaSave } from "react-icons/fa";

type U2000SaveBtnProps = {
  label: string;
  handleClick: () => void;
  disabled?: boolean;
};

const U2000SaveBtn: React.FC<U2000SaveBtnProps> = ({ label, handleClick, disabled }) => {
  return (
    <button
      className={`inline-flex items-center justify-center rounded-lg bg-green-600 px-4 py-2.5 text-sm font-medium text-white shadow-xs transition-all duration-200 
        hover:bg-green-700 hover:shadow-md 
        focus:outline-hidden focus:ring-2 focus:ring-green-500 focus:ring-offset-2 
        active:bg-green-800 active:scale-95 
        disabled:cursor-not-allowed disabled:bg-gray-400 disabled:text-gray-200 disabled:opacity-60 disabled:shadow-none`}
      onClick={() => handleClick()}
      disabled={disabled}
    >
      <FaSave className="mr-2 h-4 w-4 shrink-0" />
      <span>{label}</span>
    </button>
  );
};

export default U2000SaveBtn;
